var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaraje(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7852 17.0005H20.3571V18.9295C20.3571 19.2844 20.0691 19.5725 19.7141 19.5725H18.4282C18.0732 19.5725 17.7852 19.2844 17.7852 18.9295V17.0005Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64062 17.0005H6.2126V18.9295C6.2126 19.2844 5.92454 19.5725 5.56961 19.5725H4.28362C3.92869 19.5725 3.64062 19.2844 3.64062 18.9295V17.0005Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2126 10.5718H17.7865C19.2069 10.5718 20.3585 11.7234 20.3585 13.1438V16.3587C20.3585 16.7137 20.0704 17.0017 19.7155 17.0017H4.28362C3.92869 17.0017 3.64062 16.7137 3.64062 16.3587V13.1438C3.64062 11.7234 4.79223 10.5718 6.2126 10.5718Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 13.7866C17.8906 13.8459 17.8425 13.894 17.7832 13.894C17.7388 13.8939 17.7007 13.8671 17.6846 13.8286L17.6768 13.7866C17.677 13.7277 17.7243 13.6804 17.7832 13.6802L17.8252 13.688C17.8637 13.7041 17.8905 13.7422 17.8906 13.7866Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 13.7866C6.3125 13.8459 6.26436 13.894 6.20508 13.894C6.16069 13.8939 6.12253 13.8671 6.10645 13.8286L6.09863 13.7866C6.09886 13.7277 6.14613 13.6804 6.20508 13.6802L6.24707 13.688C6.28553 13.7041 6.31233 13.7422 6.3125 13.7866Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30036 5.42822H16.6971C16.9652 5.42822 17.205 5.59476 17.2989 5.84553L19.0717 10.5722H4.92578L6.69852 5.84553C6.79239 5.59476 7.03223 5.42822 7.30036 5.42822Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_3392_14339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99219 9.28655C2.99219 8.93143 3.28007 8.64355 3.63518 8.64355H4.27818C4.63329 8.64355 4.92117 8.93143 4.92117 9.28655C4.92117 9.64167 4.63329 9.92954 4.27818 9.92954H3.63518C3.28007 9.92954 2.99219 9.64167 2.99219 9.28655Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.99219 9.28655C2.99219 8.93143 3.28007 8.64355 3.63518 8.64355H4.27818C4.63329 8.64355 4.92117 8.93143 4.92117 9.28655C4.92117 9.64167 4.63329 9.92954 4.27818 9.92954H3.63518C3.28007 9.92954 2.99219 9.64167 2.99219 9.28655Z",
    fill: "#2B363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63518 8.64355V10.1436H4.27818V8.64355V7.14355H3.63518V8.64355ZM4.27818 9.92954V8.42954H3.63518V9.92954V11.4295H4.27818V9.92954ZM3.63518 9.92954V8.42954C4.10849 8.42954 4.49219 8.81324 4.49219 9.28655H2.99219H1.49219C1.49219 10.4701 2.45164 11.4295 3.63518 11.4295V9.92954ZM4.92117 9.28655H3.42117C3.42117 8.81324 3.80487 8.42954 4.27818 8.42954V9.92954V11.4295C5.46172 11.4295 6.42117 10.4701 6.42117 9.28655H4.92117ZM4.27818 8.64355V10.1436C3.80487 10.1436 3.42117 9.75986 3.42117 9.28655H4.92117H6.42117C6.42117 8.103 5.46172 7.14355 4.27818 7.14355V8.64355ZM3.63518 8.64355V7.14355C2.45164 7.14355 1.49219 8.10301 1.49219 9.28655H2.99219H4.49219C4.49219 9.75986 4.10849 10.1436 3.63518 10.1436V8.64355Z",
    fill: "#2B363D",
    mask: "url(#path-7-inside-1_3392_14339)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_3392_14339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0664 9.28606C19.0664 8.93094 19.3543 8.64307 19.7094 8.64307H20.3524C20.7075 8.64307 20.9954 8.93094 20.9954 9.28606C20.9954 9.64118 20.7075 9.92906 20.3524 9.92906H19.7094C19.3543 9.92906 19.0664 9.64118 19.0664 9.28606Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.0664 9.28606C19.0664 8.93094 19.3543 8.64307 19.7094 8.64307H20.3524C20.7075 8.64307 20.9954 8.93094 20.9954 9.28606C20.9954 9.64118 20.7075 9.92906 20.3524 9.92906H19.7094C19.3543 9.92906 19.0664 9.64118 19.0664 9.28606Z",
    fill: "#2B363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7094 8.64307V10.1431H20.3524V8.64307V7.14307H19.7094V8.64307ZM20.3524 9.92906V8.42906H19.7094V9.92906V11.4291H20.3524V9.92906ZM19.7094 9.92906V8.42906C20.1827 8.42906 20.5664 8.81275 20.5664 9.28606H19.0664H17.5664C17.5664 10.4696 18.5259 11.4291 19.7094 11.4291V9.92906ZM20.9954 9.28606H19.4954C19.4954 8.81275 19.8791 8.42906 20.3524 8.42906V9.92906V11.4291C21.5359 11.4291 22.4954 10.4696 22.4954 9.28606H20.9954ZM20.3524 8.64307V10.1431C19.8791 10.1431 19.4954 9.75937 19.4954 9.28606H20.9954H22.4954C22.4954 8.10252 21.5359 7.14307 20.3524 7.14307V8.64307ZM19.7094 8.64307V7.14307C18.5259 7.14307 17.5664 8.10252 17.5664 9.28606H19.0664H20.5664C20.5664 9.75937 20.1827 10.1431 19.7094 10.1431V8.64307Z",
    fill: "#2B363D",
    mask: "url(#path-9-inside-2_3392_14339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13281 13.7866H15.8487",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaraje);
export default __webpack_public_path__ + "static/media/Garaje.7be4cce663f65c35bb576ab488497c8b.svg";
export { ForwardRef as ReactComponent };